function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var PledgeCampaignApiService = /*#__PURE__*/function () {
  function PledgeCampaignApiService() {
    _classCallCheck(this, PledgeCampaignApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(PledgeCampaignApiService, [{
    key: "GetCampaign",
    value: function GetCampaign(campaignId) {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/GetPledgeCampaign?id=").concat(campaignId);
      return Ajax.Get(url);
    }
  }, {
    key: "GetFrequencyData",
    value: function GetFrequencyData() {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/GetFrequencyData");
      return Ajax.Get(url);
    }
  }, {
    key: "SavePledge",
    value: function SavePledge(formData) {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/SavePledge");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "HasPledged",
    value: function HasPledged(campaignId, contactId) {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/HasPledged?campaignId=").concat(campaignId, "&contactId=").concat(contactId);
      return Ajax.Get(url);
    }
  }, {
    key: "GetMyPledges",
    value: function GetMyPledges() {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/MyPledges");
      return Ajax.Get(url);
    }
  }, {
    key: "CancelMyPledge",
    value: function CancelMyPledge(pledgeId, cancelEmailTemplateId) {
      var url = "".concat(this._appRoot, "/Api/PledgeCampaignApi/CancelMyPledge?pledgeId=").concat(pledgeId, "&cancelEmailTemplateId=").concat(cancelEmailTemplateId);
      return Ajax.Get(url);
    }
  }]);

  return PledgeCampaignApiService;
}();